import { LeftPanelPageBreadCrumbs } from 'components/layouts/LeftPanelPageBase/components/LeftPanelPageBreadCrumbs/LeftPanelPageBreadCrumbs';
import { StringParam, useQueryParams } from 'hooks/useQueryParams';
import { useObservableState } from 'observable-hooks';
import React from 'react';
import { getUserStore } from 'stores/user.store';
import { LeftPanelPageBaseHeaderStyle as S } from './LeftPanelPageBaseHeader.style';
import { LinkText } from 'components/LinkText/LinkText';
import { YabbleLogo } from 'components/YabbleLogo/YabbleLogo';

export const LeftPanelPageBaseHeader: React.FC<{ breadCrumbs?: 'hidden' | null }> = ({ breadCrumbs }) => {
  const user = useObservableState(getUserStore().$user);
  const [queryParams] = useQueryParams({
    redirectUrl: StringParam,
  });
  return (
    <S.Container>
      <S.Header>
        <a href="https://www.yabble.com/pricing.html">
          <YabbleLogo height={24} />
        </a>
        {breadCrumbs !== 'hidden' && <LeftPanelPageBreadCrumbs />}
        {!user && (
          <S.Right>
            Already have an account?{' '}
            <LinkText
              href={`/?redirect=${
                queryParams?.redirectUrl || window.localStorage?.getItem?.('redirectUrl') || ''
              }`}
            >
              Log In
            </LinkText>
          </S.Right>
        )}
      </S.Header>
    </S.Container>
  );
};
